// package imports
import React from 'react';

// CSS imports
import './DeleteButton.css';

// Icon imports
import { FiTrash2 } from 'react-icons/fi';

type Props = {
  className?: string;
  label?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};

const DeleteButton: React.FC<Props> = ({
  className,
  label,
  disabled,
  onClick,
}: Props) => {
  return (
    <button
      className={`DeleteButton ${className ? className : ''}`}
      onClick={onClick}
      disabled={disabled ? disabled : undefined}
    >
      <FiTrash2 className={label ? 'btn-icon' : 'only-btn-icon'} />
      <b>{label ? label : null}</b>
    </button>
  );
};

export default DeleteButton;
